export var CURRENCY = /* @__PURE__ */ ((CURRENCY2) => {
  CURRENCY2["USD"] = "USD";
  CURRENCY2["CAD"] = "CAD";
  CURRENCY2["EUR"] = "EUR";
  CURRENCY2["GBP"] = "GBP";
  CURRENCY2["AUD"] = "AUD";
  CURRENCY2["BTC"] = "BTC";
  return CURRENCY2;
})(CURRENCY || {});
export var CURRENCY_SYMBOL = /* @__PURE__ */ ((CURRENCY_SYMBOL2) => {
  CURRENCY_SYMBOL2["USD"] = "$";
  CURRENCY_SYMBOL2["CAD"] = "$";
  CURRENCY_SYMBOL2["EUR"] = "\u20AC";
  CURRENCY_SYMBOL2["GBP"] = "\xA3";
  CURRENCY_SYMBOL2["BTC"] = "\xA7";
  CURRENCY_SYMBOL2["AUD"] = "$";
  return CURRENCY_SYMBOL2;
})(CURRENCY_SYMBOL || {});
export const CURRENCY_TO_SYMBOL = {
  ["USD" /* USD */]: "$" /* USD */,
  ["CAD" /* CAD */]: "$" /* CAD */,
  ["EUR" /* EUR */]: "\u20AC" /* EUR */,
  ["GBP" /* GBP */]: "\xA3" /* GBP */,
  ["BTC" /* BTC */]: "\xA7" /* BTC */,
  ["AUD" /* AUD */]: "$" /* AUD */
};
export var INSTRUMENT_TYPE = /* @__PURE__ */ ((INSTRUMENT_TYPE2) => {
  INSTRUMENT_TYPE2["CARD"] = "card";
  INSTRUMENT_TYPE2["PAYPAL"] = "paypal";
  INSTRUMENT_TYPE2["SHOPIFY"] = "shopify";
  INSTRUMENT_TYPE2["STRIPE"] = "stripe";
  return INSTRUMENT_TYPE2;
})(INSTRUMENT_TYPE || {});
export var INSTRUMENT_SUBTYPE = /* @__PURE__ */ ((INSTRUMENT_SUBTYPE2) => {
  INSTRUMENT_SUBTYPE2["ONETEXT_TOKEN"] = "onetext_token";
  INSTRUMENT_SUBTYPE2["SPREEDLY_TOKEN"] = "spreedly_token";
  INSTRUMENT_SUBTYPE2["PAYPAL_ORDER_ID"] = "paypal_order_id";
  INSTRUMENT_SUBTYPE2["PAYPAL_VAULT_SETUP_TOKEN"] = "paypal_vault_setup_token";
  INSTRUMENT_SUBTYPE2["SHOPIFY_INTENT"] = "shopify_intent";
  return INSTRUMENT_SUBTYPE2;
})(INSTRUMENT_SUBTYPE || {});
export const INSTRUMENT_LABEL = {
  ["card" /* CARD */]: "card",
  ["paypal" /* PAYPAL */]: "PayPal account",
  ["shopify" /* SHOPIFY */]: "Shopify"
};
export var PAYMENT_PLATFORM = /* @__PURE__ */ ((PAYMENT_PLATFORM2) => {
  PAYMENT_PLATFORM2["PAYPAL"] = "paypal";
  PAYMENT_PLATFORM2["STRIPE"] = "stripe";
  PAYMENT_PLATFORM2["OPENNODE"] = "opennode";
  PAYMENT_PLATFORM2["ONETEXT"] = "onetext";
  PAYMENT_PLATFORM2["AUTHORIZE_DOT_NET"] = "authorize_dot_net";
  PAYMENT_PLATFORM2["SHOPIFY"] = "shopify";
  PAYMENT_PLATFORM2["MAVERICK"] = "maverick";
  return PAYMENT_PLATFORM2;
})(PAYMENT_PLATFORM || {});
export var VAULT_PLATFORM = /* @__PURE__ */ ((VAULT_PLATFORM2) => {
  VAULT_PLATFORM2["SPREEDLY"] = "spreedly";
  VAULT_PLATFORM2["PAYPAL"] = "paypal";
  return VAULT_PLATFORM2;
})(VAULT_PLATFORM || {});
export var STORE_PLATFORM = /* @__PURE__ */ ((STORE_PLATFORM2) => {
  STORE_PLATFORM2["SHOPIFY"] = "shopify";
  STORE_PLATFORM2["WOO"] = "woo";
  return STORE_PLATFORM2;
})(STORE_PLATFORM || {});
export var ORDER_STATUS = /* @__PURE__ */ ((ORDER_STATUS2) => {
  ORDER_STATUS2["CREATED"] = "created";
  ORDER_STATUS2["COMPLETE"] = "complete";
  return ORDER_STATUS2;
})(ORDER_STATUS || {});
export var ORDER_TYPE = /* @__PURE__ */ ((ORDER_TYPE2) => {
  ORDER_TYPE2["PURCHASE"] = "purchase";
  ORDER_TYPE2["PAYMENT"] = "payment";
  return ORDER_TYPE2;
})(ORDER_TYPE || {});
export var MARKETING_PLATFORM = /* @__PURE__ */ ((MARKETING_PLATFORM2) => {
  MARKETING_PLATFORM2["ONETEXT"] = "onetext";
  MARKETING_PLATFORM2["SHOPIFY"] = "shopify";
  MARKETING_PLATFORM2["KLAVIYO"] = "klaviyo";
  MARKETING_PLATFORM2["POSTSCRIPT"] = "postscript";
  MARKETING_PLATFORM2["SENDLANE"] = "sendlane";
  MARKETING_PLATFORM2["ATTENTIVE"] = "attentive";
  MARKETING_PLATFORM2["OMNISEND"] = "omnisend";
  return MARKETING_PLATFORM2;
})(MARKETING_PLATFORM || {});
export var MARKETING_LIST_TYPE = /* @__PURE__ */ ((MARKETING_LIST_TYPE2) => {
  MARKETING_LIST_TYPE2["LIST"] = "list";
  MARKETING_LIST_TYPE2["SEGMENT"] = "segment";
  return MARKETING_LIST_TYPE2;
})(MARKETING_LIST_TYPE || {});
export var AUTHORIZATION_STATUS = /* @__PURE__ */ ((AUTHORIZATION_STATUS2) => {
  AUTHORIZATION_STATUS2["CREATED"] = "created";
  AUTHORIZATION_STATUS2["VOIDED"] = "voided";
  AUTHORIZATION_STATUS2["CAPTURED"] = "captured";
  return AUTHORIZATION_STATUS2;
})(AUTHORIZATION_STATUS || {});
export var CHARGE_STATUS = /* @__PURE__ */ ((CHARGE_STATUS2) => {
  CHARGE_STATUS2["CREATED"] = "created";
  CHARGE_STATUS2["PAID"] = "paid";
  CHARGE_STATUS2["SETTLED"] = "settled";
  CHARGE_STATUS2["PAYMENT_ERROR"] = "payment_error";
  CHARGE_STATUS2["SETTLEMENT_ERROR"] = "settlement_error";
  return CHARGE_STATUS2;
})(CHARGE_STATUS || {});
export var PAYMENT_AUTHORIZATION_ERROR = /* @__PURE__ */ ((PAYMENT_AUTHORIZATION_ERROR2) => {
  PAYMENT_AUTHORIZATION_ERROR2["DUPLICATE"] = "duplicate";
  PAYMENT_AUTHORIZATION_ERROR2["CVV_CODE_INCORRECT"] = "cvv_code_incorrect";
  PAYMENT_AUTHORIZATION_ERROR2["BILLING_ADDRESS_INCORRECT"] = "billing_address_incorrect";
  PAYMENT_AUTHORIZATION_ERROR2["BILLING_POST_CODE_INCORRECT"] = "billing_post_code_incorrect";
  PAYMENT_AUTHORIZATION_ERROR2["INSUFFICIENT_FUNDS"] = "insufficient_funds";
  PAYMENT_AUTHORIZATION_ERROR2["CARD_NUMBER_INCORRECT"] = "card_number_incorrect";
  PAYMENT_AUTHORIZATION_ERROR2["CARD_EXPIRED"] = "card_expired";
  PAYMENT_AUTHORIZATION_ERROR2["TRANSACTION_NOT_ALLOWED"] = "transaction_not_allowed";
  PAYMENT_AUTHORIZATION_ERROR2["REQUIRES_ACTION"] = "requires_action";
  PAYMENT_AUTHORIZATION_ERROR2["ZERO_AMOUNT"] = "zero_amount";
  PAYMENT_AUTHORIZATION_ERROR2["INSTRUMENT_NOT_FOUND"] = "instrument_not_found";
  return PAYMENT_AUTHORIZATION_ERROR2;
})(PAYMENT_AUTHORIZATION_ERROR || {});
export var PAYMENT_AUTHORIZATION_CAPTURE_ERROR = /* @__PURE__ */ ((PAYMENT_AUTHORIZATION_CAPTURE_ERROR2) => {
  PAYMENT_AUTHORIZATION_CAPTURE_ERROR2["ALREADY_CAPTURED"] = "already_captured";
  return PAYMENT_AUTHORIZATION_CAPTURE_ERROR2;
})(PAYMENT_AUTHORIZATION_CAPTURE_ERROR || {});
export var PAYMENT_AUTHORIZATION_REFUND_ERROR = /* @__PURE__ */ ((PAYMENT_AUTHORIZATION_REFUND_ERROR2) => {
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["REQUIRES_ADDITIONAL_TIME"] = "requires_additional_time";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["DISPUTE"] = "dispute";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["INSUFFICIENT_FUNDS"] = "insufficient_funds";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["TIME_LIMIT_EXCEEDED"] = "time_limit_exceeded";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["MERCHANT_CAN_NOT_ACCEPT_REFUND"] = "merchant_can_not_accept_refund";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["ALREADY_REFUNDED"] = "already_refunded";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["RISK_ERROR"] = "risk_error";
  PAYMENT_AUTHORIZATION_REFUND_ERROR2["REFUND_NOT_ALLOWED"] = "refund_not_allowed";
  return PAYMENT_AUTHORIZATION_REFUND_ERROR2;
})(PAYMENT_AUTHORIZATION_REFUND_ERROR || {});
export var SUBSCRIPTION_STATUS = /* @__PURE__ */ ((SUBSCRIPTION_STATUS2) => {
  SUBSCRIPTION_STATUS2["INITIATED"] = "initiated";
  SUBSCRIPTION_STATUS2["ACTIVE"] = "active";
  SUBSCRIPTION_STATUS2["CANCELED"] = "canceled";
  return SUBSCRIPTION_STATUS2;
})(SUBSCRIPTION_STATUS || {});
export var DISCOUNT_TYPE = /* @__PURE__ */ ((DISCOUNT_TYPE2) => {
  DISCOUNT_TYPE2["PERCENTAGE"] = "percentage";
  DISCOUNT_TYPE2["AMOUNT"] = "amount";
  DISCOUNT_TYPE2["CODE"] = "code";
  return DISCOUNT_TYPE2;
})(DISCOUNT_TYPE || {});
export var DISCOUNT_SUBTYPE = /* @__PURE__ */ ((DISCOUNT_SUBTYPE2) => {
  DISCOUNT_SUBTYPE2["PRICE_REDUCTION"] = "price_reduction";
  DISCOUNT_SUBTYPE2["PRODUCT_MARKDOWN"] = "product_markdown";
  DISCOUNT_SUBTYPE2["CASHBACK"] = "cashback";
  DISCOUNT_SUBTYPE2["LOYALTY"] = "loyalty";
  return DISCOUNT_SUBTYPE2;
})(DISCOUNT_SUBTYPE || {});
export var DISCOUNT_SOURCE = /* @__PURE__ */ ((DISCOUNT_SOURCE2) => {
  DISCOUNT_SOURCE2["EXISTING_DISCOUNT"] = "existing_discount";
  DISCOUNT_SOURCE2["SHOPPING_SESSION_DISCOUNT"] = "shopping_session_discount";
  DISCOUNT_SOURCE2["PROFILE_RECOVERY_DISCOUNT"] = "profile_recovery_discount";
  DISCOUNT_SOURCE2["PURCHASE_OFFER_MINIMUM_DISCOUNT"] = "purchase_offer_minimum_discount";
  DISCOUNT_SOURCE2["PRODUCT_CHOICE_MINIMUM_DISCOUNT"] = "product_choice_minimum_discount";
  return DISCOUNT_SOURCE2;
})(DISCOUNT_SOURCE || {});
export var CARD_VENDOR = /* @__PURE__ */ ((CARD_VENDOR2) => {
  CARD_VENDOR2["VISA"] = "visa";
  CARD_VENDOR2["MASTERCARD"] = "mastercard";
  CARD_VENDOR2["AMEX"] = "amex";
  CARD_VENDOR2["DISCOVER"] = "discover";
  CARD_VENDOR2["DINERS"] = "diners";
  CARD_VENDOR2["JCB"] = "jcb";
  CARD_VENDOR2["UNKNOWN"] = "unknown";
  return CARD_VENDOR2;
})(CARD_VENDOR || {});
export var SPREEDLY_CARD_VENDOR = /* @__PURE__ */ ((SPREEDLY_CARD_VENDOR2) => {
  SPREEDLY_CARD_VENDOR2["VISA"] = "visa";
  SPREEDLY_CARD_VENDOR2["MASTERCARD"] = "master";
  SPREEDLY_CARD_VENDOR2["AMEX"] = "american_express";
  SPREEDLY_CARD_VENDOR2["DISCOVER"] = "discover";
  SPREEDLY_CARD_VENDOR2["DINERS"] = "diners_club";
  SPREEDLY_CARD_VENDOR2["JCB"] = "jcb";
  SPREEDLY_CARD_VENDOR2["UNKNOWN"] = "unknown";
  return SPREEDLY_CARD_VENDOR2;
})(SPREEDLY_CARD_VENDOR || {});
export const SPREEDLY_CARD_VENDOR_TO_CARD_VENDOR = {
  ["visa" /* VISA */]: "visa" /* VISA */,
  ["master" /* MASTERCARD */]: "mastercard" /* MASTERCARD */,
  ["american_express" /* AMEX */]: "amex" /* AMEX */,
  ["discover" /* DISCOVER */]: "discover" /* DISCOVER */,
  ["diners_club" /* DINERS */]: "diners" /* DINERS */,
  ["jcb" /* JCB */]: "jcb" /* JCB */,
  ["unknown" /* UNKNOWN */]: "unknown" /* UNKNOWN */
};
export const CARD_VENDOR_TO_SPREEDLY_CARD_VENDOR = {
  ["visa" /* VISA */]: "visa" /* VISA */,
  ["mastercard" /* MASTERCARD */]: "master" /* MASTERCARD */,
  ["amex" /* AMEX */]: "american_express" /* AMEX */,
  ["discover" /* DISCOVER */]: "discover" /* DISCOVER */,
  ["diners" /* DINERS */]: "diners_club" /* DINERS */,
  ["jcb" /* JCB */]: "jcb" /* JCB */,
  ["unknown" /* UNKNOWN */]: "unknown" /* UNKNOWN */
};
export const VAULT_PLATFORM_LABEL = {
  ["paypal" /* PAYPAL */]: "PayPal"
};
export const CARD_VENDOR_LABEL = {
  ["visa" /* VISA */]: "Visa",
  ["mastercard" /* MASTERCARD */]: "Mastercard",
  ["amex" /* AMEX */]: "Amex",
  ["discover" /* DISCOVER */]: "Discover",
  ["diners" /* DINERS */]: "Diners Club",
  ["jcb" /* JCB */]: "JCB",
  ["unknown" /* UNKNOWN */]: "Unknown"
};
export var CREDIT_TYPE = /* @__PURE__ */ ((CREDIT_TYPE2) => {
  CREDIT_TYPE2["CUSTOMER_CARD_CHARGE_FEE"] = "customer_card_charge";
  CREDIT_TYPE2["CUSTOMER_CARD_CHARGE_INTERNAL"] = "customer_card_charge_internal";
  CREDIT_TYPE2["DISPUTE_REVERSAL"] = "dispute_reversal";
  CREDIT_TYPE2["MANUAL"] = "manual";
  CREDIT_TYPE2["MERCHANT_CARD_CHARGE"] = "merchant_card_charge";
  CREDIT_TYPE2["PAYOUT"] = "payout";
  CREDIT_TYPE2["EXTERNAL_PAYMENT"] = "external_payment";
  CREDIT_TYPE2["INCENTIVE"] = "incentive";
  CREDIT_TYPE2["CORRECTION"] = "correction";
  return CREDIT_TYPE2;
})(CREDIT_TYPE || {});
export var DISPUTE_STATUS = /* @__PURE__ */ ((DISPUTE_STATUS2) => {
  DISPUTE_STATUS2["WARNING_NEEDS_RESPONSE"] = "warning_needs_response";
  DISPUTE_STATUS2["WARNING_UNDER_REVIEW"] = "warning_under_review";
  DISPUTE_STATUS2["WARNING_CLOSED"] = "warning_closed";
  DISPUTE_STATUS2["NEEDS_RESPONSE"] = "needs_response";
  DISPUTE_STATUS2["UNDER_REVIEW"] = "under_review";
  DISPUTE_STATUS2["CHARGE_REFUNDED"] = "charge_refunded";
  DISPUTE_STATUS2["WON"] = "won";
  DISPUTE_STATUS2["LOST"] = "lost";
  return DISPUTE_STATUS2;
})(DISPUTE_STATUS || {});
export var DISPUTE_REASON = /* @__PURE__ */ ((DISPUTE_REASON2) => {
  DISPUTE_REASON2["BANK_CANNOT_PROCESS"] = "bank_cannot_process";
  DISPUTE_REASON2["CHECK_RETURNED"] = "check_returned";
  DISPUTE_REASON2["CREDIT_NOT_PROCESSED"] = "credit_not_processed";
  DISPUTE_REASON2["CUSTOMER_INITIATED"] = "customer_initiated";
  DISPUTE_REASON2["DEBT_NOT_AUTHORIZED"] = "debt_not_authorized";
  DISPUTE_REASON2["DUPLICATE"] = "duplicate";
  DISPUTE_REASON2["FRAUDULENT"] = "fraudulent";
  DISPUTE_REASON2["GENERAL"] = "general";
  DISPUTE_REASON2["INCORRECT_ACCOUNT_DETAILS"] = "incorrect_account_details";
  DISPUTE_REASON2["INSUFFICIENT_FUNDS"] = "insufficient_funds";
  DISPUTE_REASON2["PRODUCT_NOT_RECEIVED"] = "product_not_received";
  DISPUTE_REASON2["PRODUCT_UNACCEPTABLE"] = "product_unacceptable";
  DISPUTE_REASON2["SUBSCRIPTION_CANCELED"] = "subscription_canceled";
  DISPUTE_REASON2["UNRECOGNIZED"] = "unrecognized";
  return DISPUTE_REASON2;
})(DISPUTE_REASON || {});
export var DISPUTE_BALANCE_TRANSACTION_CATEGORY = /* @__PURE__ */ ((DISPUTE_BALANCE_TRANSACTION_CATEGORY2) => {
  DISPUTE_BALANCE_TRANSACTION_CATEGORY2["DISPUTE"] = "dispute";
  DISPUTE_BALANCE_TRANSACTION_CATEGORY2["DISPUTE_REVERSAL"] = "dispute_reversal";
  return DISPUTE_BALANCE_TRANSACTION_CATEGORY2;
})(DISPUTE_BALANCE_TRANSACTION_CATEGORY || {});
export var CVV_STATUS_CODE = /* @__PURE__ */ ((CVV_STATUS_CODE2) => {
  CVV_STATUS_CODE2["MATCHES"] = "M";
  CVV_STATUS_CODE2["DOES_NOT_MATCH"] = "N";
  CVV_STATUS_CODE2["NOT_VERIFIED"] = "U";
  CVV_STATUS_CODE2["NOT_PROVIDED"] = "I";
  CVV_STATUS_CODE2["NOT_APPLICABLE"] = "A";
  CVV_STATUS_CODE2["SKIPPED"] = "B";
  CVV_STATUS_CODE2["NO_RESPONSE"] = "X";
  return CVV_STATUS_CODE2;
})(CVV_STATUS_CODE || {});
export var AVS_STATUS_CODE = /* @__PURE__ */ ((AVS_STATUS_CODE2) => {
  AVS_STATUS_CODE2["MATCHES"] = "M";
  AVS_STATUS_CODE2["DOES_NOT_MATCH"] = "N";
  AVS_STATUS_CODE2["NOT_VERIFIED"] = "U";
  AVS_STATUS_CODE2["NOT_PROVIDED"] = "I";
  AVS_STATUS_CODE2["NOT_APPLICABLE"] = "A";
  AVS_STATUS_CODE2["SKIPPED"] = "B";
  AVS_STATUS_CODE2["ISSUER_DOES_NOT_PARTICIPATE"] = "S";
  AVS_STATUS_CODE2["SYSTEM_ERROR"] = "E";
  return AVS_STATUS_CODE2;
})(AVS_STATUS_CODE || {});
